import { render, staticRenderFns } from "./ChartingSidebarPanelDescription.vue?vue&type=template&id=d1bede30&scoped=true&"
import script from "./ChartingSidebarPanelDescription.vue?vue&type=script&lang=js&"
export * from "./ChartingSidebarPanelDescription.vue?vue&type=script&lang=js&"
import style0 from "./ChartingSidebarPanelDescription.vue?vue&type=style&index=0&id=d1bede30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bede30",
  null
  
)

export default component.exports